import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';
import { PostHogEventEnum } from '@/Domain/enum/PostHogEvent.enum';
import { capturePostHogSafely } from '@/Domain/helper/posthogCapture';
import { SCENARIO_ID } from '@/context';

export const usePostHogAnalytics = () => {
  const postHog = usePostHog();

  const capture = useCallback(
    (event: PostHogEventEnum, properties?: Record<string, unknown>) => {
      capturePostHogSafely(postHog, event, {
        scenario_id: SCENARIO_ID,
        ...properties,
      });
    },
    [postHog],
  );

  return { capture, postHog };
};
